import React, { useMemo, useState } from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import Gallery from './gallery/Gallery';
import { useZitoneoPreview } from '../../../contexts/ZitoneoContentContext';

const ALL_CATEGORY = 'all';

const HotelImagesGallery = () => {
    const { HotelImages } = useZitoneoPreview();
    const translate = useTranslate();
    const [selectedCategory, setSelectedCategory] =
        useState<string>(ALL_CATEGORY);

    const categories = useMemo(
        () => Array.from(new Set(HotelImages.map(image => image.Category))),
        [HotelImages]
    );

    const filteredImages = useMemo(
        () =>
            selectedCategory === ALL_CATEGORY
                ? HotelImages
                : HotelImages.filter(
                      image => image.Category === selectedCategory
                  ),
        [HotelImages, selectedCategory]
    );

    const galleryItems = useMemo(
        () =>
            filteredImages.map(image => ({
                src: image.Url,
                alt: image.Caption,
            })),
        [filteredImages]
    );

    if (!HotelImages.length) {
        return null;
    }

    return (
        <div className='hotel-gallery__container'>
            <Gallery
                // Remounts on category change so Gallery resets its own visible-count state.
                key={selectedCategory}
                subtitle={`${filteredImages.length} ${translate(
                    filteredImages.length === 1 ? 'photo' : 'photos'
                )}`}
                showMoreLabel={translate('show_more_photos')}
                items={galleryItems}
                title={
                    <div
                        className='hotel-gallery__tags'
                        role='group'
                        aria-label={translate('gallery')}
                    >
                        <button
                            type='button'
                            className={`hotel-gallery__tag${
                                selectedCategory === ALL_CATEGORY
                                    ? ' hotel-gallery__tag--active'
                                    : ''
                            }`}
                            aria-pressed={selectedCategory === ALL_CATEGORY}
                            onClick={() => setSelectedCategory(ALL_CATEGORY)}
                        >
                            {translate('all')}
                        </button>
                        {categories.map(category => (
                            <button
                                key={category}
                                type='button'
                                className={`hotel-gallery__tag${
                                    selectedCategory === category
                                        ? ' hotel-gallery__tag--active'
                                        : ''
                                }`}
                                aria-pressed={selectedCategory === category}
                                onClick={() => setSelectedCategory(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </div>
                }
            />
        </div>
    );
};

export default HotelImagesGallery;
